import { Signal } from "@lit-labs/signals";
import type { GetStoreConfig } from "@tanstack/router-core";

/**
 * Backs router-core's state with TC39 signals, so any `SignalWatcher` element
 * that reads `router.stores.*` in render re-renders when the route changes.
 */
export const getSignalStoreConfig: GetStoreConfig = () => ({
    createMutableStore: <T>(initialValue: T) => {
        const state = new Signal.State(initialValue);
        return {
            get: () => state.get(),
            set: (next: T | ((prev: T) => T)) =>
                state.set(typeof next === "function" ? (next as (prev: T) => T)(state.get()) : next),
        };
    },
    createReadonlyStore: <T>(read: () => T) => {
        const computed = new Signal.Computed(read);
        return { get: () => computed.get() };
    },
    // Signal watchers coalesce updates into one microtask render already.
    batch: (fn) => fn(),
});
